import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const APP_NAME = 'Vitals Portal';
export const POWERED_BY = 'Powered by The Doctors Web';

/** '<Page> | Vitals Portal', or just 'Vitals Portal' when there is no page name. */
export const formatTitle = (page) => {
    const p = page === null || page === undefined ? '' : String(page).trim();
    return p && p !== APP_NAME ? `${p} | ${APP_NAME}` : APP_NAME;
};

// Route defaults for pages that do not set their own title (pages using <MetaData> override these).
const ROUTE_TITLES = [
    [/^\/login\/?$/i, 'Login'],
    [/^\/auth\/forgot\/?$/i, 'Forgot Password'],
    [/^\/auth\/resetPassword(\/|$)/i, 'Reset Password'],
    [/^\/(adminDashboard|doctor\/dashboard|Nurse\/Dashboard|HrDashboard)\/?$/i, 'Dashboard'],
];

export const titleForPath = (pathname = '') => {
    const hit = ROUTE_TITLES.find(([re]) => re.test(pathname));
    return hit ? hit[1] : '';
};

/** Sets document.title to '<page> | Vitals Portal'. */
export const useDocumentTitle = (page) => {
    useEffect(() => {
        document.title = formatTitle(page);
    }, [page]);
};

/** Route-level default title; runs as a layout effect so a page's own useDocumentTitle (passive effect) wins. */
export const useRouteTitle = () => {
    const { pathname } = useLocation();
    useLayoutEffect(() => {
        document.title = formatTitle(titleForPath(pathname));
    }, [pathname]);
};
